import React from "react";
import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import GeneralDialog from "./GeneralDialog";

export const DomainBlockedDialog = observer(() => {
    const {modalStore, generalStore} = useStores();

    const closeModal = () => {
        modalStore.isDomainBlockedModalOpen = false;
    };

    return <GeneralDialog
        openControl='isDomainBlockedModalOpen'
        className='blue-dialog domain-expired-modal'
        title={generalStore.translate('domainBlocked')}
        body={<div>
            <div className="dialog-description">{generalStore.translate('itSeemsThatYourWorkspaceHasBeenDeactivated')}</div>
            <br/>
            <div className="dialog-description">
                <span>{generalStore.translate('ifYouWantToReactivateItPlease')}
                    <a href='mailto:support@frontline.io' target='_blank' rel='noreferrer'>{generalStore.translate('contactUs', true)}</a>
                    {generalStore.translate('at', true) + '  support@frontline.io'}
                </span>
            </div>
        </div>}
        confirmText={generalStore.translate('gotIt')}
        onConfirm={closeModal}
        noCancel
    />
})

